@if (showAccaUpdatedInfo && isAccaUpdatedInfoVisible) {
    <div class="acca-boost-notification acca-boost-notification--update-info">
        <bs-acca-boost-update-info (close)="isAccaUpdatedInfoVisible = false"></bs-acca-boost-update-info>
    </div>
}
@if (showAccaBoostIcon) {
    <div class="acca-boost-icon" [ngClass]="{ 'acca-boost-icon-enhanced': isEnhancedLayoutEnabled }">
        <bs-acca-boost-icon [showErrorIcon]="displayErrorIcon" [iconSize]="accaBoostIconSize"></bs-acca-boost-icon>
    </div>
} @else if (showInfoIcon) {
    <vn-icon name="theme-info-i" size="12" class="acca-theme-info-i"></vn-icon>
}
<div class="acca-boost-notification-content">
    <ng-content></ng-content>
</div>
@if (!usLadderEnabled) {
    @if (icon) {
        <span (click)="onClickInfo($event, true)">
            <vn-icon class="acca-boost-icon icon-theme-info" [name]="icon" [size]="accaBoostInfoIconSize"></vn-icon>
        </span>
    } @else {
        <span (click)="close()">
            <vn-icon name="theme-ex" size="12" class="acca-boost-icon icon-theme-ex"></vn-icon>
        </span>
    }
}
